export const GLOBAL_NOTICE_POPUP_ID = 'new-lnb-gnb-notice' as const;
export const LOCAL_DEV_KEY = 'local.dev' as const;

export const ROUTE_TYPE_TYPE = {
  STANDARD: 'STANDARD',
  REDIRECT: 'REDIRECT',
  STANDALONE: 'STANDALONE',
} as const;

export const SKELETON_TYPE_TYPE = {
  LIST: 'LIST',
  DETAIL: 'DETAIL',
  CREATE: 'CREATE',
} as const;

export const ROUTE_LAYOUT_TYPE = {
  CONTENTS: 'CONTENTS',
  FULL: 'FULL',
  WITH_GNB: 'WITH_GNB',
} as const;

export const TOKEN_SCOPE = {
  UNSCOPE: 'unscope',
  DOMAIN: 'domain',
  PROJECT: 'project',
} as const;

export const MENU_SCOPE = {
  CATEGORY: 'CATEGORY',
  SERVICE: 'SERVICE',
} as const;

export const GUARD_CHAIN_TYPE = {
  INITIAL: 'initial',
  ROUTE: 'route',
} as const;

export const ENV = {
  LOCAL: 'local',
  DEV: 'dev',
  STAGE: 'stage',
  CBT: 'cbt',
  PROD: 'prod',
} as const;

export const REGION = {
  KR_CENTRAL_1: 'kr-central-1',
  KR_CENTRAL_2: 'kr-central-2',
  KR_GOV_CENTRAL_1: 'kr-gov-central-1',
  KR_GOV_CENTRAL_2: 'kr-gov-central-2',
} as const;

export const PARTITION = {
  GOV: 'gov',
  PUBLIC: 'public',
} as const;

export const REGION_SUPPORT = {
  SINGLE: 'single',
  MULTI: 'multi',
} as const;

export const ENDPOINT_TYPE = {
  CONSOLE: 'console',
  ACCOUNT: 'account',
} as const;

export const QUERY_KEY = {
  PROJECT_ID: 'project_id',
  DOMAIN_ID: 'domain_id',
  REGION: 'region',
};

export const CONSOLE_VERSION = {
  UR: 'UR',
  BD: 'BD',
} as const;

export const SERVICE_MIGRATION_STATUS = {
  INCOMPLETE: 'INCOMPLETE',
  COMPLETED: 'COMPLETED',
  CUTOVER: 'CUTOVER',
} as const;

export const EXCEPTION_KEYWORD = {
  BEYOND_COMPUTE_SERVICE: '/beyond-compute-service',
  VIRTUAL_MACHINE: '/virtual-machine',
  BARE_METAL_SERVER: '/bare-metal-server',
  BEYOND_CONSOLE: 'beyond-console',
  PREVIEW_CONSOLE: 'preview-console',
} as const;

export const CONSOLE_USER_AGENT = 'Kc-Console' as const;
